import { render, staticRenderFns } from "./SuiteAppDashboard.vue?vue&type=template&id=7aac6068&"
import script from "./SuiteAppDashboard.vue?vue&type=script&lang=js&"
export * from "./SuiteAppDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports